import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ApiPartnerService } from "@app/api/api-partner.service";
import swal from "sweetalert/dist/sweetalert.min.js";

@Component({
  selector: "app-apps-list",
  templateUrl: "./apps-list.component.html",
  styleUrls: ["./apps-list.component.css"],
})
export class AppsListComponent implements OnInit {
  @ViewChild("closeBtn", { static: false }) closeBtn: ElementRef;

  listApps: any = [];
  table_load = true;
  paging: any = {};
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index: number;
  first_index: number;
  total_count: number;
  querySearch = false;
  searching = false;
  currentParams = {};
  queryParams = "";
  searchQueryParams = "";
  limit = 10;
  msearch: string;
  textSearch = new FormControl("");
  alert_act: any = [];
  formSet = this.fb.group({
    appName: [""],
    packageName: [""],
    flagActive: [""],
  });
  falsemessage: string;
  message: string;
  itemset: any = {};

  constructor(
    public partnerService: ApiPartnerService,
    private fb: FormBuilder,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.loadStart();
  }

  queryStr(options: any) {
    let params = new URLSearchParams();
    for (let key in options) {
      params.set(key, options[key]);
    }
    return params.toString();
  }

  loadStart() {
    this.route.queryParams.subscribe((params) => {
      if (params.search != "" && params.search != undefined) {
        console.log(params.search);
        this.msearch = params.search;
        this.querySearch = true;

        this.currentParams = params;
        this.queryParams = "?" + this.queryStr(params);
        this.loadApps(this.queryParams);
      } else {
        this.querySearch = false;
        this.currentParams = params;

        this.queryParams = "?" + this.queryStr(params);
        this.loadApps(this.queryParams);
      }
    });

    this.msearch = undefined;
  }

  refreshPage() {
    this.ngOnInit();
  }

  search() {
    this.querySearch = true;

    if (this.msearch == undefined) {
      this.msearch = "";
    }
    if (this.limit != undefined) {
      this.searchQueryParams =
        "?page=" + this.page_self["page"] + "&search=" + this.msearch;
    }
    this.loadApps(this.searchQueryParams);
  }

  onActionClick(act: any, item: any) {
    this.alert_act = act;

    if (this.alert_act == "add") {
      this.clearForm();
    }
    if (this.alert_act == "view") {
      this.itemset = item;
      this.loadAppDetail(this.itemset.id);
    }
  }

  clearForm() {
    this.formSet.reset();
    this.formSet.get("appName").setValue(undefined);
    this.formSet.get("packageName").setValue(undefined);
  }

  loadApps(params: any) {
    this.table_load = true;

    return this.partnerService.GetApps(params).subscribe((output: any) => {
      this.listApps = output.data;
      this.table_load = false;

      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;
      this.total_count = this.meta["totalCount"];
      let self = this.page_self["page"];
      if (self * this.meta["perPage"] < this.meta["totalCount"]) {
        this.last_index = self * this.meta["perPage"];
      } else {
        this.last_index = this.meta["totalCount"];
      }
      this.first_index = (self - 1) * this.meta["perPage"] + 1;
    });
  }

  loadAppDetail(id: any) {
    this.partnerService.GetAppDetail(id).subscribe((output: any) => {
      let data = output.data;
      this.formSet.get("appName").setValue(data.name);
      this.formSet.get("packageName").setValue(data.package_name);
      this.formSet.get("flagActive").setValue(data.flag_active.toString());
    });
  }

  private closeModal(): void {
    this.closeBtn.nativeElement.click();
  }

  alertsx(message: any) {
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
    });
    setTimeout(() => {
      this.closeModal();
      this.ngOnInit();
    }, 1000);
  }
  alertfx(message: any) {
    swal({
      title: "Gagal!",
      text: message,
      icon: "error",
    });
  }

  submitAdd() {
    let postData = {
      name: this.formSet.get("appName").value,
      package_name: this.formSet.get("packageName").value,
    };
    this.partnerService.CreateApp(postData).subscribe((output: any) => {
      if (output) {
        if (output.status == true) {
          this.message = output.message;
          this.alertsx(this.message);
          this.clearForm();
        } else {
          this.falsemessage = this.falsemessage;
          this.message = output.message;
          this.alertfx(this.message);
        }
      } else {
        this.alertfx("Error hit API");
      }
    });
  }

  submitSet() {
    let id = this.itemset.id;

    let putData = {
      name: this.formSet.get("appName").value,
      package_name: this.formSet.get("packageName").value,
      //   flag_active: this.formSet.get("flagActive").value,
      flag_active: 1,
    };

    this.partnerService.UpdateApp(id, putData).subscribe((output: any) => {
      if (output.status == true) {
        this.message = output.message;
        this.alertsx(this.message);
      } else {
        this.message = output.message;
        this.alertfx(this.message);
      }
    });
  }

  submitDelete() {
    let id = this.itemset.id;
    swal({
      title: "Are you sure?",
      text: '"' + this.itemset.name + '" Akan dihapus',
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.partnerService.DeleteApp(id).subscribe((output: any) => {
          if (output.status == true) {
            this.message = output.message;
            this.alertsx(this.message);
          } else {
            this.message = output.message;
            this.alertfx(this.message);
          }
        });
      }
    });
  }
}
